// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container-container-v3Thl {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 32px 24px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/page-container/page-container.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 32px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `page-container-container-v3Thl`
};
export default ___CSS_LOADER_EXPORT___;
